const getters = {
    smWarehouses: state => state.sm_warehouses,
    smWarehouse: state => state.sm_warehouse,
}

export default getters;
